module.exports = __webpack_public_path__ + "static/media/Computer Error-SoundBible.com-399240903.bbf5fc51.mp3";